module.exports = __webpack_public_path__ + "19dc0f4c415d353d44fd79fc08bd2c34.png";